<template>
  <router-link to="/results">
    <img src="@/assets/close.png" alt />
  </router-link>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
img {
  user-select: none;
  position: absolute;
  top: rems(10px);
  right: rems(10px);
  cursor: pointer;
  width: rems(62px);
  height: rems(62px);
}
</style>
